package meineglasfaser.frontend.common.components.widgets

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Hr
import org.jetbrains.compose.web.dom.Li

@Composable
fun LiHr() {
    Li(
        attrs = {
            classes("hr")
        }
    ) {
        Hr()
    }
}
